let nextKey = 1;

// FE-only identity of an editor object (`feKey`) — React key of the object
// panel form; server ids can't serve, unsaved objects don't have one. Never
// sent to the API (createLayoutRequestBody strips it).
export const createLayoutObjectKey = (): number => {
  const key = nextKey;
  nextKey += 1;
  return key;
};
